import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props} viewBox='0 0 24 24'>
    <path d='M10 12.261L4.028 3.972h16L14 12.329V17l-4 3z' />
  </Base>
)
